import type { FootballSide, Maybe, PenaltyScore } from '@swf/generated/graphql/scoreboards/schemas';

const getPenaltyScore = (
  side: FootballSide,
  penaltyScores?: Maybe<PenaltyScore[]>
): number | undefined =>
  penaltyScores?.filter(
    (penaltyScore) => penaltyScore.side === side && penaltyScore.shotResult === 'SCORE'
  ).length;

export default getPenaltyScore;
